import React from "react";
import {DotsHorizontalIcon, MinusIcon, PaperClipIcon, PhotographIcon, StarIcon} from "@heroicons/react/outline";
import styled from "styled-components";
import {ActionWithIcon, Button} from "../../../core";
import {NewTooltip} from "../../../reorganize/new-tooltip";
import {PopupMenu} from "../../../old/popup-menu";
import {Popover2} from "@blueprintjs/popover2";

const Brackets = () => <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" width="16" height="16"
                            viewBox="0, 0, 16, 16">
    <g id="Layer_1">
        <path
            d="M4.816,1.011 C3.844,1.081 2.986,1.591 2.462,2.41 C2.273,2.709 2.132,3.074 2.044,3.5 C2.032,3.554 2.02,4.113 2.011,4.874 C2,6.02 1.995,6.168 1.967,6.266 C1.874,6.579 1.638,6.832 1.338,6.945 C1.232,6.983 1.193,6.987 0.613,6.992 L-0,6.999 L-0,8.003 L-0,9.008 L0.55,9.008 C0.854,9.008 1.146,9.017 1.2,9.027 C1.359,9.057 1.556,9.161 1.68,9.279 C1.812,9.405 1.9,9.542 1.958,9.718 C2,9.846 2,9.855 2.013,11.13 C2.021,11.994 2.032,12.45 2.046,12.523 C2.169,13.144 2.44,13.666 2.865,14.1 C3.213,14.455 3.623,14.71 4.078,14.854 C4.463,14.977 4.725,15.005 5.466,15.005 L5.997,15.005 L5.997,14 L5.997,12.994 L5.417,12.994 C4.899,12.994 4.827,12.991 4.725,12.959 C4.565,12.91 4.373,12.791 4.271,12.676 C4.169,12.564 4.05,12.326 4.023,12.184 C4.011,12.124 4.004,11.641 4.004,10.966 C4.004,9.752 3.993,9.57 3.902,9.233 C3.791,8.818 3.566,8.389 3.296,8.076 L3.232,8.003 L3.32,7.901 C3.593,7.581 3.825,7.119 3.921,6.705 C3.995,6.393 4.004,6.229 4.004,5.059 C4.004,3.795 4.006,3.779 4.125,3.543 C4.25,3.294 4.521,3.086 4.793,3.03 C4.851,3.018 5.117,3.009 5.445,3.009 L5.997,3.009 L5.997,2.004 L5.997,0.998 L5.449,1.002 C5.146,1.004 4.862,1.007 4.816,1.011 z M10.003,2.002 L10.003,0.995 L10.662,1.004 C11.476,1.014 11.643,1.039 12.087,1.211 C13.142,1.619 13.889,2.608 13.987,3.73 C13.998,3.846 14.007,4.433 14.007,5.032 C14.007,6.229 14.007,6.224 14.121,6.461 C14.193,6.611 14.378,6.797 14.534,6.881 C14.731,6.985 14.821,6.995 15.441,6.995 L16,6.995 L16,8.003 L16,9.008 L15.441,9.008 C14.815,9.008 14.724,9.02 14.532,9.128 C14.307,9.254 14.167,9.416 14.067,9.669 L14.017,9.792 L14.005,11.066 C13.998,11.903 13.986,12.381 13.972,12.458 C13.828,13.27 13.422,13.937 12.78,14.418 C12.36,14.733 11.811,14.94 11.275,14.988 C11.159,14.998 10.824,15.005 10.532,15.005 L10.003,15.005 L10.003,14 L10.003,12.994 L10.579,12.994 C11.212,12.994 11.251,12.989 11.469,12.878 C11.613,12.806 11.808,12.611 11.88,12.469 C11.998,12.235 11.994,12.261 11.996,11.086 C11.996,10.497 12.003,9.913 12.014,9.79 C12.063,9.152 12.297,8.581 12.724,8.057 L12.768,8.001 L12.667,7.874 C12.279,7.391 12.063,6.839 12.014,6.213 C12.003,6.09 11.996,5.509 11.996,4.92 C11.994,3.742 11.998,3.768 11.88,3.536 C11.806,3.391 11.613,3.197 11.465,3.123 C11.263,3.021 11.179,3.011 10.56,3.011 L10.003,3.009 L10.003,2.002 z"
            fill="currentColor"/>
    </g>
</svg>;

const button_theme = {
    active: 'sc-toolbar-button-active',
    button: 'sc-toolbar-button',
    buttonWrapper: 'sc-toolbar-button-wrapper'
};

const Btn = styled.button`
  height: 26px;
  width: 26px;
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    height: 18px;
    width: 18px;
  }
`;

// <CodeButton {...externalProps} theme={button_theme} />
// <CodeBlockButton {...externalProps} theme={button_theme} />

const Separator = styled.div`
  width: 1px;
  background: #cdcdcd;
  margin-top: 4px;
  margin-bottom: 7px;
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
`;

function buildMergeTags(merge_tags, insertTag) {
    let final = [];

    merge_tags.forEach(group => {
        final.push({
            type: 'submenu',
            title: group.label,
            use_portal: false,
            width: "225px",
            items: group.tags.map(tag => {
                return {
                    type: 'item',
                    title: tag.label,
                    subtitle: tag.subtitle,
                    onClick: () => insertTag(tag.subtitle)
                }
            })
        })
    })

    return final;
}

export function ScStaticToolbar({
                                    merge_tags = [],
                                    onAddImage = () => {
                                    },
                                    onAddDivider = () => {
                                    },
                                    insertTag = () => {},
                                    onAddCustomBlock = () => {},
                                    onAddAttachment = () => {
                                    },
                                    onAddSignature = () => {
                                    }
                                }) {

    //

    const options = [
        {
            type: 'item',
            title: 'Add Signature',
            onClick: () => onAddSignature()
        }
    ];

    const dynamic_data_options = buildMergeTags(merge_tags, insertTag);

    return <div className="flex space-x-3 px-1">
        <div>
            <NewTooltip usePortal={false} message="Add Image">
                <ActionWithIcon size="lg" icon={<PhotographIcon/>} onClick={() => onAddImage()}/>
            </NewTooltip>
        </div>
        <div>
            <NewTooltip usePortal={false} message="Add Attachment">
                <ActionWithIcon size="lg" icon={<PaperClipIcon/>} onClick={() => onAddAttachment()}/>
            </NewTooltip>
        </div>
        <div>
            <NewTooltip usePortal={false} message="Divider">
                <ActionWithIcon size="lg" icon={<MinusIcon/>} onClick={() => onAddDivider()}/>
            </NewTooltip>
        </div>
        <div>
            <Popover2 interactionKind="click" usePortal={false}
                      content={<PopupMenu width={"225px"} items={dynamic_data_options}/>} placement={'bottom-start'}
                      minimal
                      popoverClassName='minimal-popover'>
                <div>
                    <NewTooltip usePortal={false} message="Dynamic Data">
                        <ActionWithIcon stopPropogation={false} onClick={() => {
                        }} size="lg" icon={<div style={{height: '18px'}} className="h-svg-4 flex items-center">
                            <Brackets/></div>}/>
                    </NewTooltip>
                </div>
            </Popover2>
        </div>
        <div>
            <Popover2 interactionKind="click" usePortal={false} content={<PopupMenu items={options}/>}
                      placement={'bottom-start'} minimal
                      popoverClassName='minimal-popover'>
                <ActionWithIcon stopPropogation={false} size="lg" icon={<DotsHorizontalIcon/>} onClick={() => {
                }}/>
            </Popover2>
        </div>
        <div className="hidden">
            <NewTooltip usePortal={false} message="Custom">
                <ActionWithIcon size="lg" icon={<StarIcon/>} onClick={() => onAddCustomBlock()}/>
            </NewTooltip>
        </div>
    </div>
}